import { createRouter, createMemoryHistory } from 'vue-router';
import UserInformation from './components/dashboard/UserInformation';
import PaymentInformation from './components/dashboard/PaymentInformation';
import SupportRequest from './components/dashboard/SupportRequest';
import { default as t } from './utils/translationStrings';
import smoothScroll from './utils/smoothScroll';

export const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: UserInformation,
    meta: {
      title: t.dashboard.myData,
      description: t.dashboardPage.myDataDesc,
      icon: 'user',
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component: PaymentInformation,
    meta: {
      title: t.dashboard.paymentInformation,
      description: t.dashboardPage.paymentInfoDesc,
      icon: 'euro',
    },
  },
  {
    path: '/support-request',
    name: 'support-request',
    component: SupportRequest,
    meta: {
      title: t.dashboard.supportRequest,
      icon: 'house',
    },
  },
];

export const router = createRouter({
  history: createMemoryHistory(),
  routes,
  scrollBehavior: () => {
    smoothScroll(0, 400);
  },
});
